import { handleApiError, IOmniaShell, LocaleString, omniaResolve } from "../omnia"
import { getSelectedLayers, refreshState } from "./state"
import { State } from "./types"

export function deleteLayers(state: State, shell: IOmniaShell): PromiseLike<State | false> {

    const { layerSvc } = state

    const selection = getSelectedLayers(state, undefined)

    const n = selection.length

    if (!n) {
        return omniaResolve(false)
    }

    return shell.showMessageBox({
        templateUrl: "app/datalayers/mgr/delete.html",
        arguments: {
            selectionLabel: getLayerStmt(n)
        }
    }).then(ok => {

        if (!ok) {
            return false
        }

        const ids = selection.map(s => s.layer.DataLayerId)

        return layerSvc.deleteLayers(ids, false)
            .then(() => refreshState(state))
            .catch(e => handleApiError(shell, e).then(() => false))

    })

}


export function enableOrDisableLayers(state: State, disable: boolean, shell: IOmniaShell): PromiseLike<State | false> {

    const { layerSvc } = state

    const selection = getSelectedLayers(state, disable)

    const n = selection.length

    if (!n) {
        return omniaResolve(false)
    }

    let [title, content] = disable
        ? [
            "Disable layers" as LocaleString,
            `<p>This will disable the ${getLayerStmt(n)}.</p>
            <p>Disabled layers will not be visible anymore in Omnia, but are not deleted, and can be enabled back later</p>` as LocaleString
        ]
        : [
            "Enable layers" as LocaleString,
            `<p>This will enable the ${getLayerStmt(n)}.</p>` as LocaleString
        ]

    content += "<p>Do you want to continue?</p>" as LocaleString

    return omnia.shell.showOkCancel(shell, content, title).then(ok => {

        if (!ok) {
            return false
        }

        const ids = selection.map(s => s.layer.DataLayerId)

        return layerSvc.enableOrDisableLayers(ids, disable)
            .then(() => refreshState(state))
            .catch(e => handleApiError(shell, e).then(() => false))

    })

}

function getLayerStmt(n: number) {
    return n > 1
        ? `${String(n)} selected layers` as LocaleString
        : "selected layer" as LocaleString
}
